class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
  }

  connectedCallback() {
    this.performRecommendations();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  performRecommendations() {
    const recommendations = this.querySelector('[data-recommendations]');
    if (!recommendations) return;
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const recommendationsHMTL = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-recommendations]').innerHTML;
        if (!recommendationsHMTL) return;
        this.classList.remove('hidden');
        recommendations.innerHTML = recommendationsHMTL;
        this.initSlider();
      });
  }

  handleClick(e) {
    // Select Variant
    const selectBtn = e.target.closest('.js-rec-select-variant');
    if (selectBtn) {
      e.preventDefault();
      // Ignore if unavailable
      if (selectBtn.classList.contains('is-unavailable')) return;

      // Update selected state
      const panel = selectBtn.closest('.cart-recommendations__variants-panel');
      if (!panel) return;
      panel.querySelectorAll('.js-rec-select-variant').forEach(btn => btn.classList.remove('is-selected'));
      selectBtn.classList.add('is-selected');

      // Update Add to Cart Button
      const addWrapper = panel.querySelector('.cart-recommendations__add');
      if (addWrapper) addWrapper.style.display = 'flex';

      const addBtn = panel.querySelector('.js-rec-add-to-cart') || panel.querySelector('.cart-recommendations__add-btn');
      if (addBtn) {
        addBtn.dataset.variantId = selectBtn.dataset.variantId;
        const isAvailable = selectBtn.dataset.available === 'true';
        if (isAvailable) {
          addBtn.disabled = false;
          addBtn.textContent = '+ VOEG TOE';
          addBtn.classList.remove('is-disabled');
          addBtn.classList.add('js-rec-add-to-cart');
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'UITVERKOCHT';
          addBtn.classList.add('is-disabled');
          addBtn.classList.remove('js-rec-add-to-cart');
        }
      }
      return;
    }

    // Add to cart
    const addBtn = e.target.closest('.js-rec-add-to-cart');
    if (!addBtn) return;

    e.preventDefault();
    const variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    addBtn.disabled = true;
    addBtn.classList.add('is-loading');

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        if (data.status) throw new Error(data.description);
        document.dispatchEvent(new Event('sw:added', { bubbles: true }));
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.refreshCartDrawer();
      })
      .catch(err => {
        console.error('Recommendation add to cart error:', err);
      })
      .finally(() => {
        addBtn.disabled = false;
        addBtn.classList.remove('is-loading');
      });
  }



  initSlider() {
    const prevBtn = this.querySelector('.cart-recommendations__nav-prev');
    const nextBtn = this.querySelector('.cart-recommendations__nav-next');

    this.slider = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 8,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
        disabledClass: 'is-disabled'
      }
    });
  }
}

customElements.define('cart-recommendations', CartRecommendations);
